import { SETTING } from "@/shared/utils/settings/constants";
import { Theme } from "@/shared/utils/theme/theme";
import {
  DefaultThemeIdLandingApp,
  DefaultThemeIdEasyModeApp,
  ThemesLandingApp,
  ThemesEasyModeApp
} from "../theme";
import {
  SETTINGS_VALIDATORS,
} from "@/shared/utils/settings/validators";

export const LITE_APP_SETTINGS_VALIDATORS = {
  ...SETTINGS_VALIDATORS,
  [SETTING.themeMode.id]: (v) => v in Theme && ThemesEasyModeApp.includes(Theme[v]),
};

export const LANDING_APP_SETTINGS_VALIDATORS = {
  ...SETTINGS_VALIDATORS,
  [SETTING.themeMode.id]: (v) => v in Theme && ThemesLandingApp.includes(Theme[v]),
};

export const LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP = {
  [SETTING.themeMode.id]: DefaultThemeIdEasyModeApp,
};

export const LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP = {
  [SETTING.themeMode.id]: DefaultThemeIdLandingApp,
};
